"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("cross-fetch/polyfill");
const post = async (config, event, correlationKey, createdAt) => {
    const data = Object.assign({}, event, { api_key: config.apiKey, consumer_key: config.consumerKey, correlation_key: correlationKey, entity_key: config.entityKey, created_at: createdAt });
    try {
        const response = await fetch(config.endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        if (response.status !== 201) {
            throw new Error(`failed posting event with status code ${response.status}`);
        }
        return response.json();
    }
    catch (err) {
        throw new Error(`failed posting event, ${err.message || err}`);
    }
};
exports.default = {
    post,
};
